import axios from "axios";
import { onMounted, onUnmounted, getCurrentInstance } from 'vue';

/**
 * Composable for managing OneSignal push notification subscriptions using Composition API
 * @returns {Object} Notification management methods
 */
export function useNotifications() {
    const instance = getCurrentInstance();
    const oneSignal = instance?.appContext.config.globalProperties.$OneSignal;
    const emitter = instance?.appContext.config.globalProperties.emitter;
    
    let subscriptionChangeHandler = null;

    /**
     * Handle push subscription changes
     */
    const handleSubscriptionChange = async (e) => {
        if (e.current.id != '' && e.current.id != undefined) {
            try {
                const response = await axios.post(
                    process.env.VUE_APP_API_BASE + "auth/notificationSubcriptionChange",
                    {
                        token: e.current.id,
                        service: 'onesignal',
                        status: e.current.optedIn
                    },
                    {
                        headers: {
                            "Content-type": "application/json",
                            Authorization: "Bearer " + localStorage.getItem("token"),
                        },
                    }
                );
                
                if (emitter) {
                    emitter.emit('showFlashAlertMessage', { 
                        message: response.data.message, 
                        level: 'success' 
                    });
                }
            } catch (error) {
                if (emitter) {
                    emitter.emit('showFlashAlertMessage', { 
                        message: 'Oops, something went wrong. Please try again later!', 
                        level: 'error' 
                    });
                }
            }
        }
    };

    /**
     * Setup push subscription event listener
     */
    const setupSubscriptionListener = () => {
        if (oneSignal?.User?.PushSubscription) {
            subscriptionChangeHandler = handleSubscriptionChange;
            oneSignal.User.PushSubscription.addEventListener("change", subscriptionChangeHandler);
        }
    };

    /**
     * Cleanup push subscription event listener
     */
    const cleanupSubscriptionListener = () => {
        if (oneSignal?.User?.PushSubscription && subscriptionChangeHandler) {
            oneSignal.User.PushSubscription.removeEventListener("change", subscriptionChangeHandler);
            subscriptionChangeHandler = null;
        }
    };

    // Auto-setup on mount and cleanup on unmount
    onMounted(() => {
        setupSubscriptionListener();
    });

    onUnmounted(() => {
        cleanupSubscriptionListener();
    });

    return {
        handleSubscriptionChange,
        setupSubscriptionListener,
        cleanupSubscriptionListener
    };
}

// Legacy mixin export for backward compatibility
export default {
    mounted() {
        var localEmitter = this.emitter;
        this._notificationChangeHandler = (e) => {
            if (e.current.id != '' && e.current.id != undefined) {
                axios
                    .post(
                        process.env.VUE_APP_API_BASE + "auth/notificationSubcriptionChange",
                        {
                            token: e.current.id,
                            service: 'onesignal',
                            status: e.current.optedIn
                        },
                        {
                            headers: {
                                "Content-type": "application/json",
                                Authorization: "Bearer " + localStorage.getItem("token"),
                            },
                        }).then((response) => {
                            localEmitter.emit('showFlashAlertMessage', { message: response.data.message, level: 'success' });
                        }).catch(() => {
                            localEmitter.emit('showFlashAlertMessage', { message: 'Oops, something went wrong. Please try again later!', level: 'error' });
                        }
                    );
            }
        };
        
        if (this.$OneSignal?.User?.PushSubscription) {
            this.$OneSignal.User.PushSubscription.addEventListener("change", this._notificationChangeHandler);
        }
    },
    beforeUnmount() {
        if (this.$OneSignal?.User?.PushSubscription && this._notificationChangeHandler) {
            this.$OneSignal.User.PushSubscription.removeEventListener("change", this._notificationChangeHandler);
        }
    }
};

